import { default as axios, default as Client } from "../utils/client";
export const postSell = async () => {
  await axios.post("/");
};

export function getOffers(type, cities, corps, search_word, page,priceSort) {
  const _cities = `"state":{"$in":[${cities}]}`;
  const _corps = `"subCategory_id":{"$in":[${corps}]}`;
  const filters = search_word ? `&or=offer||$cont||${search_word}` : null;

  const s =
    `{"offer_type":"${type}"` +
    `${cities.length > 0 ? "," + _cities : ""}` +
    `${corps.length > 0 ? "," + _corps : ""}` +
    "}";
  // return Client.get("/offer?sort=created_at,DESC&s=" + s.toString() + filters && filters.toString()).then((res) => res.data);
  const sortQuery =
  priceSort === "asc" || priceSort === "desc"
    ? `&sort=${priceSort.toUpperCase()}`
    : "";


  return Client.post(`/offers/searchV2?page=${page}${sortQuery}`, {
    search_word: search_word ?? "",
    sub_category: corps.length !== 0 ? corps : null,
    state: cities.length !== 0 ? cities : null,
    type: type,
  }).then((res) => res.data);
}

export function getMyOffers(id) {
  return Client.get(`/offer?s={"owner":"${id}"}`).then((res) => res.data);
}

export function getAuctions(cities, corps, search_word) {
  return Client.post("/auction/searchV2", {
    search_word: !search_word ? "" : search_word,
    sub_category: corps.length !== 0 ? corps : null,
    state: cities.length !== 0 ? cities : null,
  }).then((res) => res.data);
}

export function getSingleAuction(id) {
  return Client.get("/auction/" + id).then((res) => res.data);
}

export function getCurrentBiddings() {
  return Client.get("/biddings").then((res) => res.data);
}
export function allowedUsers(id) {
  return Client.get("/biddings/verified-user/" + id).then((res) => res.data);
}

export function getMe() {
  return Client.get("/users/me").then((res) => res.data);
}

export function getBlogs() {
  return Client.get("/admin/blogs?limit=100&page=1").then(
    (res) => res.data
  );
}
export function getBlog(id) {
  return Client.get("/admin/blogs/" + id).then((res) => res.data);
}

export function getPrices() {
  return Client.get("/price").then((res) => res.data);
}
export function getWeather(long, lat) {
  return Client.get("/weather/" + long + "/" + lat).then((res) => res.data);
}

export function getCategories() {
  return Client.get("/categories/subCategories").then((res) => res.data);
}

export function getStates() {
  return Client.get("/state").then((res) => res.data);
}

export function getCities() {
  return Client.get("/cities/").then((res) => res.data);
}

export function getmarkets() {
  return Client.get("/markets/").then((res) => res.data);
}

export function getLocality() {
  return Client.get("/locality/").then((res) => res.data);
}

export function getCitiesByState(state) {
  return Client.get("/cities/" + state).then((res) => res.data);
}

export function getmarketsByState(state) {
  return Client.get("/markets/" + state).then((res) => res.data);
}

export function getLocalityByState(state) {
  return Client.get("/locality/" + state).then((res) => res.data);
}

export function getSingleOffer(id) {
  return Client.get("/Offer/" + id).then((res) => res.data);
}
export function getInput(id) {
  return Client.get(`/inputs/${id}`).then((res) => res.data);
}

export function getUnits() {
  return Client.get("/units/").then((res) => res.data);
}

export function getServices(type, cities, services, search_word, page,priceSort) {
  const sortQuery =
  priceSort === "asc" || priceSort === "desc"
    ? `&sort=${priceSort.toUpperCase()}`
    : "";


  return Client.post(`/services/search?page=${page}${sortQuery}`, {
    search_word: search_word ?? "",
    service: services.length !== 0 ? services : null,
    state: cities.length !== 0 ? cities : null,
    type: type ?? null,
  }).then((res) => res.data);
}

export function getVehicleTypes() {
  return Client.get("/services/vehicle_type").then((res) => res.data);
}

export function getBids(id) {
  return Client.get("/biddings/" + id).then((res) => res.data);
}

export function getAllServices() {
  return Client.get("/services/all").then((res) => res.data);
}
export function getSingleService(id) {
  return Client.get("/services/single/" + id).then((res) => res.data);
}

export function getOfferFavorites() {
  return Client.get("/favorites/offers").then((res) => res.data);
}
export function getServicesFavorites() {
  return Client.get("/favorites/services").then((res) => res.data);
}
export function getInputsFavorites() {
  return Client.get("/favorites/inputs").then((res) => res.data);
}

export function getSingleFavorites(id) {
  return Client.get("/favorites/" + id).then((res) => res.data);
}
export function getServicesTypes() {
  return Client.get("/services").then((res) => res.data);
}

export function getFavorites() {
  return Client.get("/favorites").then((res) => res.data);
}

export function getUserConversations() {
  return Client.get("/advisor/conversation").then((res) => res.data);
}
export function getInputsCategories() {
  return Client.get("/inputs/categories").then((res) => res.data);
}

export function getUser() {
  return Client.get("/users/profile").then((res) => res.data);
}

export function getInputs(type, cities, category, search_word, page,priceSort) {
  const sortQuery =
  priceSort === "asc" || priceSort === "desc"
    ? `&sort=${priceSort.toUpperCase()}`
    : "";

  return Client.post(`/inputs/searchV2?page=${page}${sortQuery}`, {
    search_word: search_word ?? "",
    category: category.length !== 0 ? category : null,
    state: cities.length !== 0 ? cities : null,
    type: type ?? null,
  }).then((res) => res.data);
}

export function getAlert(id){
  return Client.get("/alerts/"+id).then((res) => res.data);
}

export const getGallery = async () => {
  try {
    const response = await Client.get("/gallery?isActive=true&sort=sortOrder,ASC");
    return response.data;
  } catch (error) {
    console.error('Error fetching gallery:', error);
    throw error;
  }
};

export async function logActivity(action, productType = null, productId = null, isAuth = false) {
  try {
    const user_id = localStorage.getItem("user_id");
    await Client.post("/admin/logs", {
      user_id: isAuth ? user_id : null,
      action,
      product_type: productType,
      product_id: productId,
    });
  } catch (error) {
    console.error("Failed to log activity:", error);
  }
}

// SalatMahsool (platform product catalog)

export function getSalatProducts(page, limit, categoryId, stateId, search) {
  const params = new URLSearchParams();
  if (page) params.set("page", page);
  if (limit) params.set("limit", limit);
  if (categoryId) params.set("category_id", categoryId);
  if (stateId) params.set("state_id", stateId);
  if (search) params.set("search", search);
  return Client.get(`/salat-mahsool/products?${params.toString()}`).then((res) => res.data);
}

export function getSalatProduct(id) {
  return Client.get(`/salat-mahsool/products/${id}`).then((res) => res.data);
}

export function getSalatCategories() {
  return Client.get("/salat-mahsool/categories").then((res) => res.data);
}

export function createSalatOrder(dto) {
  return Client.post("/salat-mahsool/orders", dto).then((res) => res.data);
}

export function getSalatOrders() {
  return Client.get("/salat-mahsool/orders").then((res) => res.data);
}

export function getSalatOrder(id) {
  return Client.get(`/salat-mahsool/orders/${id}`).then((res) => res.data);
}

export function cancelSalatOrder(id) {
  return Client.patch(`/salat-mahsool/orders/${id}/cancel`).then((res) => res.data);
}
